(function () {
  'use strict';

  var drawer     = document.getElementById('cart-drawer');
  var overlay    = document.getElementById('cart-drawer-overlay');
  var closeBtn   = document.getElementById('cart-drawer-close');
  var loadingEl  = document.getElementById('cart-drawer-loading');
  var itemsEl    = document.getElementById('cart-drawer-items');
  var emptyEl    = document.getElementById('cart-drawer-empty');
  var footerEl   = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-drawer-subtotal-price');
  var countEl    = document.getElementById('cart-drawer-count');
  var continueBtn = document.getElementById('cart-drawer-continue');
  var announceEl = document.getElementById('cart-drawer-announce');

  if (!drawer) return;

  var isOpen       = false;
  var isRefreshing = false;
  var focusTrigger = null;

  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var confettiLastFired    = 0;

  function formatMoney(cents) {
    var sym = (typeof getCurrencySymbol === 'function') ? getCurrencySymbol() : 'C$';
    return sym + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function announce(msg) {
    if (!announceEl) return;
    announceEl.textContent = '';
    setTimeout(function () { announceEl.textContent = msg; }, 50);
  }

  function showLoading() {
    if (loadingEl) loadingEl.style.display = 'flex';
  }
  function hideLoading() {
    if (loadingEl) loadingEl.style.display = 'none';
  }

  function openDrawer(trigger) {
    if (isOpen) return;
    focusTrigger = trigger || document.activeElement;
    isOpen = true;
    drawer.removeAttribute('aria-hidden');
    drawer.classList.add('open');
    if (overlay) {
      overlay.removeAttribute('aria-hidden');
      overlay.classList.add('open');
    }
    document.body.classList.add('cart-drawer-open');
    requestAnimationFrame(function () {
      var focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    });
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('open');
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('open');
    }
    document.body.classList.remove('cart-drawer-open');
    if (focusTrigger && typeof focusTrigger.focus === 'function') {
      focusTrigger.focus();
    }
    focusTrigger = null;
  }

  function getFocusable() {
    return Array.from(drawer.querySelectorAll(
      'a[href]:not([tabindex="-1"]),button:not([disabled]):not([tabindex="-1"]),input:not([disabled]):not([tabindex="-1"]),[tabindex="0"]'
    )).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) { closeDrawer(); return; }
    if (e.key !== 'Tab' || !isOpen) return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function apiGet() {
    return fetch(rootUrl + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // FormData, not JSON — same Meta in-app browser issue as apiAdd() below.
  function apiChange(key, qty) {
    var fd = new FormData();
    fd.append('id', key);
    fd.append('quantity', qty);
    return fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    }).then(function (r) { return r.json(); });
  }

  function apiUpdateProps(key, qty, props) {
    return fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, properties: props })
    }).then(function (r) { return r.json(); });
  }

  function apiSwapToBase(itemKey, baseVariantId, qty) {
    return apiChange(itemKey, 0).then(function () {
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(baseVariantId, 10), quantity: qty }] })
      });
    }).then(function () {
      return apiGet();
    });
  }

  // Accepts either a FormData (from a real <form> submit — preferred) or a
  // plain object (used by the quick-add recommendation buttons, which have
  // no form). Always sent as multipart/form-data, NOT JSON: Meta's in-app
  // browser (Instagram/Facebook) is known to mishandle fetch() calls whose
  // body is JSON.stringify()'d with an explicit application/json
  // Content-Type — requests silently fail there. Sending FormData instead
  // (browser sets the multipart Content-Type itself, same as a native form
  // POST) avoids that failure mode entirely.
  function apiAdd(payload) {
    var fd;
    if (payload instanceof FormData) {
      fd = payload;
    } else {
      fd = new FormData();
      Object.keys(payload).forEach(function (k) {
        if (k === 'properties' && payload.properties) {
          Object.keys(payload.properties).forEach(function (pk) {
            fd.append('properties[' + pk + ']', payload.properties[pk]);
          });
        } else if (payload[k] !== undefined && payload[k] !== null) {
          fd.append(k, payload[k]);
        }
      });
    }
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) { throw e; }, function () {
          throw { description: 'Could not add to cart. Please try again.' };
        });
      }
      return r.json();
    });
  }

  function fireConfetti() {
    if (prefersReducedMotion) return;
    var now = Date.now();
    if (now - confettiLastFired < 2000) return;
    confettiLastFired = now;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:99999;pointer-events:none;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    var colors = ['#e10600','#16794f','#FFD700','#ffffff','#ff4d6d','#4895ef'];
    var particles = [];
    for (var i = 0; i < 160; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height * -1,
        w: Math.random() * 9 + 4,
        h: Math.random() * 5 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        vx: (Math.random() - 0.5) * 5,
        vy: Math.random() * 4 + 2,
        rot: Math.random() * 360,
        rotV: (Math.random() - 0.5) * 10,
        g: 0.12
      });
    }
    var start = null;
    var dur   = 3500;
    function draw(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      particles.forEach(function (p) {
        p.x += p.vx; p.y += p.vy; p.vy += p.g; p.rot += p.rotV;
        if (p.y < canvas.height + 40) alive = true;
        var alpha = Math.max(0, 1 - Math.max(0, elapsed - 2000) / 1500);
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.globalAlpha = alpha;
        ctx.fillStyle   = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (alive && elapsed < dur) requestAnimationFrame(draw);
      else canvas.remove();
    }
    requestAnimationFrame(draw);
  }

  // Shopify's /cart.js, /cart/add.js and /cart/change.js responses do NOT
  // include a compare_at_price field on line items — even when the variant
  // genuinely has one set in the admin. Only /products/{handle}.js reliably
  // returns it. We cache it per variant_id the first time we see a product,
  // so markdown savings work correctly on every cart render, not just the
  // very first server-rendered (Liquid) paint of the drawer.
  var compareAtCache = {};

  function fetchProductCompareAt(handle) {
    return fetch(rootUrl + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        (p.variants || []).forEach(function (v) {
          compareAtCache[v.id] = v.compare_at_price || 0;
        });
      })
      .catch(function () {});
  }

  function ensureCompareAtData(items) {
    var handlesToFetch = {};
    items.forEach(function (item) {
      if (item.variant_id != null && !(item.variant_id in compareAtCache) && item.handle) {
        handlesToFetch[item.handle] = true;
      }
    });
    var handles = Object.keys(handlesToFetch);
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(fetchProductCompareAt));
  }

  function getCompareAt(item) {
    if (item.variant_id != null && compareAtCache[item.variant_id] != null) {
      return compareAtCache[item.variant_id] || null;
    }
    return item.compare_at_price || null;
  }

  function updateProgressEl(progressEl, cart) {
    if (!progressEl) return;
    var threshold    = parseInt(progressEl.getAttribute('data-threshold'), 10) || 9900;
    var cartCents    = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
    var remaining    = Math.max(0, threshold - cartCents);
    var pct          = Math.min(100, Math.round(cartCents / threshold * 100));
    var qualified    = cartCents >= threshold;
    var wasQualified = progressEl.classList.contains('fsp-progress--qualified');
    var msgBefore    = progressEl.getAttribute('data-msg-before') || "Almost there, add {{ amount_remaining }} more to get [FREE SHIPPING!]";
    var msgAfter     = progressEl.getAttribute('data-msg-after')  || "[Congratulations!] You've got free shipping!";
    var barFill      = progressEl.getAttribute('data-bar-fill') || '#e10600';

    var formattedRemaining = formatMoney(remaining);

    // [text] -> <strong class="fsp-highlight">text</strong>, escaped first so
    // nothing from a theme setting can inject real markup.
    function renderHighlight(tpl) {
      var parts = tpl.split(/\[([^\]]*)\]/);
      var out = '';
      for (var i = 0; i < parts.length; i++) {
        out += (i % 2 === 1) ? '<strong class="fsp-highlight">' + esc(parts[i]) + '</strong>' : esc(parts[i]);
      }
      return out;
    }

    var msgHtml;
    if (qualified) {
      msgHtml = renderHighlight(msgAfter);
    } else {
      var parts = msgBefore.split('{{ amount_remaining }}');
      msgHtml = renderHighlight(parts[0]) + '<span class="fsp-amount">' + esc(formattedRemaining) + '</span>' + renderHighlight(parts[1] || '');
    }

    var msgEl   = progressEl.querySelector('.fsp-progress__msg');
    var trackEl = progressEl.querySelector('.fsp-progress__track');
    var fillEl  = progressEl.querySelector('.fsp-progress__fill');

    if (msgEl)   msgEl.innerHTML = msgHtml;
    if (trackEl) trackEl.setAttribute('aria-valuenow', pct);
    if (fillEl) {
      fillEl.style.width = pct + '%';
      fillEl.style.setProperty('--fsp-fill-color', qualified ? '#16794f' : barFill);
    }

    if (qualified) progressEl.classList.add('fsp-progress--qualified');
    else           progressEl.classList.remove('fsp-progress--qualified');

    if (qualified && !wasQualified) {
      announce(msgAfter);
      fireConfetti();
    }
  }

  function updateProgress(cart) {
    updateProgressEl(document.getElementById('fsp-progress'), cart);
    updateProgressEl(document.getElementById('fsp-progress-cart'), cart);
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.header-actions a[aria-label="Cart"]').forEach(function (link) {
      var badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else {
        if (badge) badge.remove();
      }
    });

    document.querySelectorAll('.cart-count:not(.header-actions .cart-count)').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function dispatchUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));
  }

  function renderCart(cart) {
    renderCartBody(cart);
    ensureCompareAtData(cart.items || []).then(function () {
      renderCartBody(cart);
    });
  }

  function renderCartBody(cart) {
    var items = cart.items || [];

    var displayCount = cart.item_count || 0;
    if (countEl) countEl.textContent = displayCount ? '(' + displayCount + ')' : '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);

    var isEmpty = displayCount === 0;

    show(emptyEl,   isEmpty);
    show(itemsEl,   !isEmpty);
    show(footerEl,  !isEmpty);
    if (emptyEl)  emptyEl.setAttribute('aria-hidden',  String(!isEmpty));

    if (isEmpty) return;

    var html = '';
    for (var di = 0; di < items.length; di++) {
      var item = items[di];

      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" width="80" height="80" loading="lazy" class="cart-drawer-item-img">'
        : '<div class="cart-drawer-item-img cart-drawer-item-img--placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="4" y="4" width="16" height="16" rx="2"/></svg></div>';

      var typeHtml = item.product_type
        ? '<div class="cart-drawer-item-type">' + esc(item.product_type) + '</div>' : '';

      // Show only the color (first option), hiding "/ Engraved", "/ None", or "Default Title"
      var _opt0 = item.variant_options && item.variant_options[0];
      var colorDisplay = (_opt0 && _opt0 !== 'Default Title' && _opt0 !== 'None' && _opt0 !== 'Engraved')
        ? _opt0 : '';
      var variantHtml = colorDisplay
        ? '<div class="cart-drawer-item-variant">' + esc(colorDisplay) + '</div>' : '';

      var spHtml = item.selling_plan_allocation
        ? '<div class="cart-drawer-item-selling-plan">' + esc(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';

      // Show non-hidden, non-engraving properties
      var propsHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && k !== 'Engraving Text' && k !== 'Engraving Style' && item.properties[k] !== '') {
            propsHtml += '<div class="cart-drawer-item-prop"><span class="prop-label">' + esc(k) + ':</span> <span class="prop-value">' + esc(item.properties[k]) + '</span></div>';
          }
        });
        if (propsHtml) propsHtml = '<div class="cart-drawer-item-props">' + propsHtml + '</div>';
      }

      var compareAtPrice = getCompareAt(item);
      var hasDiscount = item.original_price > item.final_price;
      var hasCompareAt = compareAtPrice && compareAtPrice > item.original_price;
      var onSale = hasDiscount || hasCompareAt;
      var referencePrice = hasCompareAt ? Math.max(compareAtPrice, item.original_price) : item.original_price;
      var wasPrice = referencePrice > item.final_price ? referencePrice * item.quantity : null;
      var priceHtml = '<span class="cart-drawer-item-price' + (onSale ? ' is-sale' : '') + '">' + formatMoney(item.final_line_price) + '</span>';
      if (wasPrice) {
        priceHtml += '<span class="cart-drawer-item-price-was">' + formatMoney(wasPrice) + '</span>';
      }

      // Engraving section — detected by property, not by a separate fee item
      var engravingHtml = '';
      var hasEngraving = !!(item.properties && item.properties['Engraving Text']);
      if (hasEngraving) {
        var engText  = item.properties['Engraving Text']  || '';
        var engStyle = item.properties['Engraving Style'] || 'Block';
        var baseVid  = item.properties['_base_variant']   || '';
        engravingHtml =
          '<div class="cd-engraving" data-item-key="' + esc(item.key) + '" data-item-qty="' + item.quantity + '" data-base-variant="' + esc(baseVid) + '">' +
            '<div class="cd-engraving-summary">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13" aria-hidden="true" style="flex-shrink:0"><path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>' +
              '<span class="cd-eng-detail">' + esc(engText) + ' &middot; ' + esc(engStyle) + '</span>' +
              '<button type="button" class="cd-eng-edit">Edit</button>' +
              '<button type="button" class="cd-eng-remove">Remove</button>' +
            '</div>' +
            '<div class="cd-engraving-panel" style="display:none;">' +
              '<input type="text" class="cd-eng-text-input" maxlength="20" value="' + esc(engText) + '" placeholder="Your engraving text">' +
              '<div class="cd-eng-panel-actions">' +
                '<button type="button" class="cd-eng-save">Save</button>' +
                '<button type="button" class="cd-eng-cancel">Cancel</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }

      html +=
        '<div class="cart-drawer-item" data-key="' + esc(item.key) + '">' +
          '<a href="' + esc(item.url) + '" class="cart-drawer-item-img-link" tabindex="-1" aria-label="' + esc(item.title) + '">' +
            imgHtml +
          '</a>' +
          '<div class="cart-drawer-item-details">' +
            '<div class="cart-drawer-item-meta">' +
              typeHtml +
              '<a href="' + esc(item.url) + '" class="cart-drawer-item-title">' + esc(item.title) + '</a>' +
              variantHtml + spHtml + propsHtml + engravingHtml +
            '</div>' +
            '<div class="cart-drawer-item-row">' +
              '<div class="cart-drawer-qty" role="group" aria-label="Quantity">' +
                '<button type="button" class="cart-drawer-qty-btn" data-action="decrease" aria-label="Decrease quantity">&#8722;</button>' +
                '<input type="number" class="cart-drawer-qty-val" value="' + item.quantity + '" min="0" aria-label="Quantity" data-key="' + esc(item.key) + '">' +
                '<button type="button" class="cart-drawer-qty-btn" data-action="increase" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="cart-drawer-item-price-wrap">' + priceHtml + '</div>' +
              '<button type="button" class="cart-drawer-remove" data-key="' + esc(item.key) + '" aria-label="Remove ' + esc(item.title) + ' from cart">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    if (itemsEl) {
      itemsEl.innerHTML = html;
      bindItemEvents();
    }

    var totalSavings = 0;
    items.forEach(function (item) {
      var cAt = getCompareAt(item);
      if (cAt && cAt > item.original_price) {
        totalSavings += (cAt - item.original_price) * item.quantity;
      }
    });
    // Discount codes (and any automatic cart-level discounts) are reported
    // authoritatively by Shopify on the cart object itself, so we add that
    // on top of markdown savings rather than trying to infer it per line.
    totalSavings += cart.total_discount || 0;
    var savingsEl    = document.getElementById('cart-drawer-savings');
    var savingsAmtEl = document.getElementById('cart-drawer-savings-amount');
    if (savingsEl) {
      if (totalSavings > 0) {
        savingsEl.style.display = '';
        if (savingsAmtEl) savingsAmtEl.textContent = formatMoney(totalSavings);
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  function show(el, visible) {
    if (!el) return;
    el.style.display = visible ? '' : 'none';
    if (!visible) el.setAttribute('hidden', '');
    else          el.removeAttribute('hidden');
  }

  function refreshCart() {
    if (isRefreshing) return Promise.resolve(null);
    isRefreshing = true;
    showLoading();
    return apiGet().then(function (cart) {
      isRefreshing = false;
      hideLoading();
      renderCart(cart);
      updateProgress(cart);
      updateHeaderCount(cart.item_count);
      dispatchUpdated(cart);
      return cart;
    }).catch(function () {
      isRefreshing = false;
      hideLoading();
      return null;
    });
  }

  function bindItemEvents() {
    if (!itemsEl) return;

    itemsEl.querySelectorAll('.cart-drawer-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemEl = btn.closest('.cart-drawer-item');
        if (!itemEl) return;
        var key   = itemEl.dataset.key;
        var input = itemEl.querySelector('.cart-drawer-qty-val');
        var cur   = parseInt(input ? input.value : 1, 10) || 1;
        var next  = btn.dataset.action === 'decrease' ? cur - 1 : cur + 1;
        next = Math.max(0, next);
        disableItemControls(itemEl, true);
        showLoading();
        apiChange(key, next).then(function (cart) {
          hideLoading();
          renderCart(cart);
          updateProgress(cart);
          updateHeaderCount(cart.item_count);
          dispatchUpdated(cart);
          announce(next === 0 ? 'Item removed from cart' : 'Quantity updated');
        }).catch(function () {
          hideLoading();
          disableItemControls(itemEl, false);
          announce('Could not update quantity. Please try again.');
        });
      });
    });

    itemsEl.querySelectorAll('.cart-drawer-qty-val').forEach(function (input) {
      input.addEventListener('change', function () {
        var itemEl = input.closest('.cart-drawer-item');
        if (!itemEl) return;
        var key  = input.dataset.key;
        var next = Math.max(0, parseInt(input.value, 10) || 0);
        disableItemControls(itemEl, true);
        showLoading();
        apiChange(key, next).then(function (cart) {
          hideLoading();
          renderCart(cart);
          updateProgress(cart);
          updateHeaderCount(cart.item_count);
          dispatchUpdated(cart);
        }).catch(function () {
          hideLoading();
          disableItemControls(itemEl, false);
        });
      });
    });

    itemsEl.querySelectorAll('.cart-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        showLoading();
        apiChange(key, 0).then(function (cart) {
          hideLoading();
          renderCart(cart);
          updateProgress(cart);
          updateHeaderCount(cart.item_count);
          dispatchUpdated(cart);
          announce('Item removed from cart');
        }).catch(function () {
          hideLoading();
          announce('Could not remove item. Please try again.');
        });
      });
    });

    // Engraving: Remove — swap engraved variant back to base variant
    itemsEl.querySelectorAll('.cd-eng-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var engWrap = btn.closest('.cd-engraving');
        if (!engWrap) return;
        var itemKey   = engWrap.dataset.itemKey;
        var baseVid   = engWrap.dataset.baseVariant;
        var itemQty   = parseInt(engWrap.dataset.itemQty, 10) || 1;
        if (!itemKey || !baseVid) return;
        showLoading();
        apiSwapToBase(itemKey, baseVid, itemQty).then(function (cart) {
          hideLoading();
          renderCart(cart);
          updateProgress(cart);
          updateHeaderCount(cart.item_count);
          dispatchUpdated(cart);
          announce('Engraving removed');
        }).catch(function () {
          hideLoading();
          announce('Could not remove engraving. Please try again.');
        });
      });
    });

    // Engraving: Open Edit panel
    itemsEl.querySelectorAll('.cd-eng-edit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var engWrap = btn.closest('.cd-engraving');
        if (!engWrap) return;
        engWrap.querySelector('.cd-engraving-summary').style.display = 'none';
        engWrap.querySelector('.cd-engraving-panel').style.display = '';
      });
    });

    // Engraving: Style toggle inside edit panel
    itemsEl.querySelectorAll('.cd-eng-style-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.cd-engraving-panel');
        if (!panel) return;
        panel.querySelectorAll('.cd-eng-style-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });

    // Engraving: Save — update properties on same variant
    itemsEl.querySelectorAll('.cd-eng-save').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel   = btn.closest('.cd-engraving-panel');
        var engWrap = btn.closest('.cd-engraving');
        if (!panel || !engWrap) return;
        var itemKey = engWrap.dataset.itemKey;
        var itemQty = parseInt(engWrap.dataset.itemQty, 10) || 1;
        var baseVid = engWrap.dataset.baseVariant || '';
        var textEl = panel.querySelector('.cd-eng-text-input');
        var text   = textEl ? textEl.value.trim() : '';
        var style  = 'Block';
        if (!text) { if (textEl) textEl.focus(); return; }
        btn.disabled = true;
        showLoading();
        apiUpdateProps(itemKey, itemQty, {
          'Engraving Text': text,
          'Engraving Style': style,
          '_base_variant': baseVid
        }).then(function (cart) {
          hideLoading();
          renderCart(cart);
          updateProgress(cart);
          updateHeaderCount(cart.item_count);
          dispatchUpdated(cart);
        }).catch(function () {
          hideLoading();
          btn.disabled = false;
          announce('Could not save engraving. Please try again.');
        });
      });
    });

    // Engraving: Cancel edit
    itemsEl.querySelectorAll('.cd-eng-cancel').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var engWrap = btn.closest('.cd-engraving');
        if (!engWrap) return;
        engWrap.querySelector('.cd-engraving-panel').style.display = 'none';
        engWrap.querySelector('.cd-engraving-summary').style.display = '';
      });
    });
  }

  function disableItemControls(itemEl, disabled) {
    if (!itemEl) return;
    itemEl.querySelectorAll('button,input').forEach(function (el) {
      el.disabled = disabled;
    });
  }

  document.querySelectorAll('.header-actions a[aria-label="Cart"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen) { closeDrawer(); return; }
      refreshCart().then(function () { openDrawer(link); });
    });

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        link.click();
      }
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.getAttribute !== 'function') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;

    e.preventDefault();
    e.stopPropagation();

    var submitBtn = form.querySelector('[type="submit"]');
    var origHTML  = submitBtn ? submitBtn.innerHTML : '';
    var origDis   = submitBtn ? submitBtn.disabled : false;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = '&#8230;'; }

    var fd = new FormData(form);
    var autoOpen = drawer.getAttribute('data-auto-open') !== 'false';

    apiAdd(fd).then(function () {
      if (submitBtn) {
        submitBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16" style="vertical-align:middle" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg> Added';
        setTimeout(function () {
          submitBtn.innerHTML = origHTML;
          submitBtn.disabled  = origDis;
        }, 1400);
      }
      if (autoOpen) openDrawer(submitBtn || form);
      return refreshCart();
    }).then(function (cart) {
      if (!cart) return;
      announce('Item added to cart');
    }).catch(function (err) {
      if (submitBtn) { submitBtn.innerHTML = origHTML; submitBtn.disabled = origDis; }
      var msg = (err && err.description) ? err.description
              : (err && err.message)     ? err.message
              : 'Could not add to cart. Please try again.';

      var errEl = form.querySelector('.cart-drawer-form-error');
      if (!errEl) {
        errEl = document.createElement('p');
        errEl.className = 'cart-drawer-form-error';
        errEl.setAttribute('role', 'alert');
        var anchor = submitBtn ? (submitBtn.parentNode || form) : form;
        anchor.appendChild(errEl);
      }
      errEl.textContent = msg;
      setTimeout(function () { if (errEl.parentNode) errEl.remove(); }, 6000);
    });
  }, true);

  // Track current product view for recommendations
  (function () {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!m) return;
    fetch(rootUrl + 'products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p && p.id) {
          try { localStorage.setItem('_cd_pid', String(p.id)); } catch (e) {}
        }
      })
      .catch(function () {});
  }());

  var recsContainer = document.getElementById('cart-drawer-recs');
  if (recsContainer) {
    (function () {
      var colProducts = [];
      try {
        var colEl = document.getElementById('cart-rec-col-data');
        if (colEl) colProducts = JSON.parse(colEl.textContent || '[]');
      } catch (e) {}

      function shopifyImgSrc(url, size) {
        if (!url) return '';
        return url.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_' + size + 'x$1$3');
      }

      function renderRecs(products) {
        if (!products || !products.length) return;
        var track = document.getElementById('cart-drawer-recs-track');
        if (!track) return;

        var html = products.map(function (p) {
          var imgUrl = p.image || '';
          var imgHtml = imgUrl
            ? '<a href="' + esc(p.url) + '" class="cart-drawer-rec-img-link" tabindex="-1"><div class="cart-drawer-rec-img-wrap"><img src="' + esc(imgUrl) + '" alt="' + esc(p.title) + '" loading="lazy" class="cart-drawer-rec-img"></div></a>'
            : '<div class="cart-drawer-rec-img-wrap cart-drawer-item-img--placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="4" y="4" width="16" height="16" rx="2"/></svg></div>';
          var isSingleVariant = p.variants_count === 1;
          var actionHtml = isSingleVariant
            ? '<button type="button" class="cart-drawer-rec-action cart-drawer-rec-atc" data-variant-id="' + esc(p.variant_id) + '">Add to Cart</button>'
            : '<a href="' + esc(p.url) + '" class="cart-drawer-rec-action cart-drawer-rec-shop">Shop Now</a>';
          return (
            '<div class="cart-drawer-rec-card">' +
              imgHtml +
              '<div class="cart-drawer-rec-info">' +
                '<a href="' + esc(p.url) + '" class="cart-drawer-rec-title">' + esc(p.title) + '</a>' +
                '<span class="cart-drawer-rec-price">' + formatMoney(p.price) + '</span>' +
              '</div>' +
              actionHtml +
            '</div>'
          );
        }).join('');

        track.innerHTML = html;
        recsContainer.removeAttribute('hidden');

        track.querySelectorAll('.cart-drawer-rec-atc').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
            if (!vid) return;
            btn.disabled = true;
            btn.textContent = '…';
            apiAdd({ id: vid, quantity: 1 }).then(function () {
              btn.textContent = '✓ Added';
              return refreshCart();
            }).then(function () {
              setTimeout(function () {
                btn.textContent = 'Add to Cart';
                btn.disabled = false;
              }, 1500);
            }).catch(function () {
              btn.textContent = 'Add to Cart';
              btn.disabled = false;
            });
          });
        });

        var prevBtn = document.getElementById('cart-rec-prev');
        var nextBtn = document.getElementById('cart-rec-next');
        if (!prevBtn || !nextBtn) return;
        var cards = track.querySelectorAll('.cart-drawer-rec-card');
        var total = cards.length;
        var current = 0;
        var maxIdx = Math.max(0, total - 3);
        function updateNav() {
          prevBtn.disabled = current === 0;
          nextBtn.disabled = current >= maxIdx;
        }
        function goTo(idx) {
          current = Math.max(0, Math.min(idx, maxIdx));
          var cardW = cards[0] ? (cards[0].offsetWidth + 8) : 0;
          track.style.transform = 'translateX(-' + (current * cardW) + 'px)';
          updateNav();
        }
        prevBtn.addEventListener('click', function () { goTo(current - 1); });
        nextBtn.addEventListener('click', function () { goTo(current + 1); });
        updateNav();
      }

      var pid;
      try { pid = localStorage.getItem('_cd_pid'); } catch (e) {}

      if (pid) {
        fetch(rootUrl + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data && data.products;
            if (products && products.length) {
              renderRecs(products.map(function (p) {
                return {
                  url: p.url,
                  title: p.title,
                  price: p.price_min,
                  image: shopifyImgSrc(p.featured_image, 240),
                  variants_count: p.variants ? p.variants.length : 1,
                  variant_id: p.variants && p.variants[0] ? p.variants[0].id : null
                };
              }));
            } else {
              renderRecs(colProducts);
            }
          })
          .catch(function () { renderRecs(colProducts); });
      } else {
        renderRecs(colProducts);
      }
    }());
  }

  if (closeBtn)    closeBtn.addEventListener('click', closeDrawer);
  if (overlay)     overlay.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart) {
      updateProgress(cart);
      updateHeaderCount(cart.item_count);
    }
  });

  (function initDisplayStates() {
    var isEmpty = !itemsEl || itemsEl.hasAttribute('hidden');
    show(emptyEl,  isEmpty);
    show(itemsEl,  !isEmpty);
    show(footerEl, !isEmpty);
    hideLoading();
  }());
  bindItemEvents();

  // Inject engraving-section styles once
  (function () {
    if (document.getElementById('cd-engraving-styles')) return;
    var s = document.createElement('style');
    s.id = 'cd-engraving-styles';
    s.textContent = [
      '.cd-engraving{margin-top:6px;font-size:12px;}',
      '.cd-engraving-summary{display:flex;align-items:center;gap:5px;flex-wrap:wrap;}',
      '.cd-eng-detail{flex:1;color:#555;font-style:italic;}',
      '.cd-eng-edit,.cd-eng-remove{background:none;border:1px solid currentColor;border-radius:4px;padding:2px 7px;font-size:11px;cursor:pointer;line-height:1.4;}',
      '.cd-eng-edit{color:#1a1a1a;}.cd-eng-edit:hover{background:#f0f0f0;}',
      '.cd-eng-remove{color:#c0392b;}.cd-eng-remove:hover{background:#fdf0ef;}',
      '.cd-engraving-panel{margin-top:6px;display:flex;flex-direction:column;gap:6px;}',
      '.cd-eng-text-input{width:100%;box-sizing:border-box;padding:5px 8px;border:1px solid #ccc;border-radius:4px;font-size:13px;}',
      '.cd-eng-styles{display:flex;gap:6px;}',
      '.cd-eng-style-btn{flex:1;padding:4px 0;border:1px solid #ccc;border-radius:4px;background:#fff;cursor:pointer;font-size:12px;}',
      '.cd-eng-style-btn.active{border-color:#1a1a1a;background:#1a1a1a;color:#fff;}',
      '.cd-eng-panel-actions{display:flex;gap:6px;}',
      '.cd-eng-save{flex:1;padding:5px 0;background:#1a1a1a;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:12px;}',
      '.cd-eng-save:hover{background:#333;}',
      '.cd-eng-cancel{flex:1;padding:5px 0;background:#fff;color:#1a1a1a;border:1px solid #ccc;border-radius:4px;cursor:pointer;font-size:12px;}',
      '.cd-eng-cancel:hover{background:#f0f0f0;}'
    ].join('');
    document.head.appendChild(s);
  }());

  window.CartDrawer = {
    open:    openDrawer,
    close:   closeDrawer,
    refresh: refreshCart
  };

}());
